// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "zay-status button.selectbtn {\n  width: 200px;\n  height: 35px;\n}", ""]);
// Exports
module.exports = exports;
